"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.generateMerkleTree = void 0;
function generateMerkleTree() {
    return {
        leaf: [
            '0000000000000000000000000000000000000000',
            '0000000000000000000000000000000000000000',
            '0000000000000000000000000000000000000000',
            '0000000000000000000000000000000000000000',
        ],
        challenges: [
            Buffer.from('00000000000000000000000000000000', 'hex'),
            Buffer.from('00000000000000000000000000000000', 'hex'),
            Buffer.from('00000000000000000000000000000000', 'hex'),
            Buffer.from('00000000000000000000000000000000', 'hex'),
        ],
        challenges_as_str: [
            '00000000000000000000000000000000',
            '00000000000000000000000000000000',
            '00000000000000000000000000000000',
            '00000000000000000000000000000000',
        ],
        preleaf: [
            Buffer.from('0000000000000000000000000000000000000000', 'hex'),
            Buffer.from('0000000000000000000000000000000000000000', 'hex'),
            Buffer.from('0000000000000000000000000000000000000000', 'hex'),
            Buffer.from('0000000000000000000000000000000000000000', 'hex'),
        ],
    };
}
exports.generateMerkleTree = generateMerkleTree;
